import { firestore } from './firestore';
import { ITeam, IUserTeam } from '../types';
import { getCollectionsByFilter } from './common';
import { collection, doc, writeBatch } from 'firebase/firestore';
import { IUser } from '@todesktop/shared';

export const getUserTeamsData = async (id: IUser['id']) =>
  getCollectionsByFilter<IUserTeam>(collection(firestore, 'users_teams'), {
    firstWhere: {
      fieldPath: 'userId',
      opStr: '==',
      value: id,
    },
  });

export const createNewUserNewTeamBatch = async ({
  id,
  avatar,
  email,
  firstName,
  lastName,
}: IUser) => {
  const batch = writeBatch(firestore);

  const team: ITeam = { name: email ?? '', stripeCustomerId: null };
  const teamRef = doc(collection(firestore, 'teams'));
  batch.set(teamRef, team);

  const userTeamRef = doc(collection(firestore, 'users_teams'));
  const userTeam: IUserTeam = {
    userId: id,
    teamId: teamRef.id,
    teamName: team.name,
    userName: firstName && lastName ? `${firstName} ${lastName}` : '',
    userEmail: email ?? '',
    userAvatar: avatar || null,
    userRole: 'owner',
  };
  batch.set(userTeamRef, userTeam);

  await batch.commit();
};
